import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { burstConfetti } from '../utils'

function CommandPalette() {
  const [open, setOpen] = useState(false)
  const [q, setQ] = useState('')
  const [sel, setSel] = useState(0)
  const inputRef = useRef(null)
  const navigate = useNavigate()

  const items = useMemo(() => [
    { label: 'Go to Home', hint: 'page', run: () => navigate('/') },
    { label: 'Go to About', hint: 'page', run: () => navigate('/about') },
    { label: 'Go to Projects', hint: 'page', run: () => navigate('/project') },
    { label: 'Go to Resume', hint: 'page', run: () => navigate('/resume') },
    { label: 'Toggle dark mode', hint: 'theme', run: () => window.dispatchEvent(new Event('toggle-theme')) },
    { label: 'Open GitHub', hint: 'link', run: () => window.open('https://github.com/Amaan-AeonX', '_blank', 'noreferrer') },
    { label: 'Open LinkedIn', hint: 'link', run: () => window.open('https://www.linkedin.com/in/amaan-akbany5/', '_blank', 'noreferrer') },
    { label: 'Celebrate 🎉', hint: 'fun', run: () => setTimeout(() => burstConfetti(), 150) },
  ], [navigate])

  const results = items.filter(i => i.label.toLowerCase().includes(q.toLowerCase()))

  useEffect(() => {
    const onKey = e => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen(o => !o)
      } else if (e.key === 'Escape') setOpen(false)
    }
    const onOpen = () => setOpen(true)
    window.addEventListener('keydown', onKey)
    window.addEventListener('open-palette', onOpen)
    return () => {
      window.removeEventListener('keydown', onKey)
      window.removeEventListener('open-palette', onOpen)
    }
  }, [])

  useEffect(() => {
    if (open) { setQ(''); setSel(0); setTimeout(() => inputRef.current && inputRef.current.focus(), 30) }
  }, [open])

  const choose = item => { setOpen(false); item.run() }

  const onKeyDown = e => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSel(s => (s + 1) % Math.max(results.length, 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel(s => (s - 1 + results.length) % Math.max(results.length, 1)) }
    else if (e.key === 'Enter' && results[sel]) choose(results[sel])
  }

  if (!open) return null
  return (
    <div className="palette-overlay" onClick={() => setOpen(false)}>
      <div className="palette" role="dialog" aria-modal="true" aria-label="Command palette" onClick={e => e.stopPropagation()}>
        <input
          ref={inputRef}
          value={q}
          onChange={e => { setQ(e.target.value); setSel(0) }}
          onKeyDown={onKeyDown}
          placeholder="Type a command or search…"
          aria-label="Search commands"
        />
        <ul>
          {results.map((r, i) => (
            <li key={r.label} className={i === sel ? 'sel' : ''} onMouseEnter={() => setSel(i)} onClick={() => choose(r)}>
              <span>{r.label}</span><small>{r.hint}</small>
            </li>
          ))}
          {results.length === 0 && <li className="empty">No matches</li>}
        </ul>
      </div>
    </div>
  )
}

export default CommandPalette
